import Vue from "vue";
import { format } from "date-fns";

export default {
  getDocumentos() {
    return Vue.prototype.$http.get("/documentos");
  },

  getDocumento(id) {
    return Vue.prototype.$http.get(`/documentos/${id}`);
  },

  postDocumento(documento) {
    const form = new FormData();
    form.append("file", documento.file);
    form.append("data", documento.data);
    form.append("tipo", documento.tipo);

    // Valide e adicione o idAcessoPessoa
    if (!documento.idAcessoPessoa && !documento.idAcessoDispositivo) {
      throw new Error("idAcessoPessoa ou idAcessoDispositivo não definido!");
    }
    if (documento.idAcessoPessoa) {
      form.append("idAcessoPessoa", documento.idAcessoPessoa);
    }

    if (documento.idAcessoDispositivo) {
      form.append("idAcessoDispositivo", documento.idAcessoDispositivo);
    }

    const configHeader = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    return Vue.prototype.$http.post("/documentos", form, configHeader);
  },

  getDocumentosAcesso(idAcessoPessoa) {
    return Vue.prototype.$http.get(`/documentos/acessoPessoa/${idAcessoPessoa}`);
  },

  getDocumentosAcessoDispositivo(idAcessoDispositivo) {
    return Vue.prototype.$http.get(`/documentos/acessoDispositivo/${idAcessoDispositivo}`);
  },

  deleteDocumento(id) {
    return Vue.prototype.$http.delete(`/documentos/${id}`);
  },

  getFoto(nomeFoto) {
    return Vue.prototype.$http.get(`/documentos/foto/${nomeFoto}`, {
      responseType: "blob",
    });
  },

  baixarDoc(nomeDoc) {
    return Vue.prototype.$http.get(`/documentos/baixarDoc/${nomeDoc}`, {
      responseType: "blob",
    });
  },
};
